if (!customElements.get("custom-slider")) {
class CustomSlider extends HTMLElement {
  constructor() {
    super();
    this.splideEl = this.querySelector(".splide");
    this.mountSplider();
  }

  async mountSplider() {
    if (this.splideEl) {
      try {
        this.options = await JSON.parse(this.splideEl.dataset.sliderOptions || '{}');
        const splideInstance = new Splide(this.splideEl, this.options);
        
        splideInstance.on('mounted move updated', () => {
          attachReadToggleListeners(); // re-run after any slide update
        });

        splideInstance.mount();
      } catch (e) {
        console.error("Error parsing slider options:", e);
      }
    }
  }
}

customElements.define("custom-slider", CustomSlider);
}

class TestimonialFlip extends HTMLElement {
  constructor() {
    super();
    this.viewProductBtn = this.querySelector(".testimonial-slider__card-view-product-btn");
    this.closeProductBtn = this.querySelector(".testimonial-slider__product-close-btn");

    if (this.viewProductBtn && this.closeProductBtn) {
      this.viewProductBtn.addEventListener("click", this.viewProductClick.bind(this));
      this.closeProductBtn.addEventListener("click", this.closeProductClick.bind(this));
    }
  }

  viewProductClick() {
    this.querySelector(".testimonial-slider__flip-card-inner").classList.add("active");
    if(this.parentElement.classList.contains("expanded")) {
      this.parentElement.style.height = "197px";
    }
  }
  
  closeProductClick() {
    this.querySelector(".testimonial-slider__flip-card-inner").classList.remove("active");
    if(this.parentElement.classList.contains("expanded")) {
      this.parentElement.style.height = "240px";
    }
  }
}

customElements.define("testimonial-flip", TestimonialFlip);

function attachReadToggleListeners() {
  document.querySelectorAll(".testimonial-slider__slide").forEach(function (wrapper) {
    const toggleBtn = wrapper.querySelector(".read-toggle");
    const desc = wrapper.querySelector(".testimonial_description");

    // Prevent double binding
    if (!toggleBtn || toggleBtn.dataset.listenerAttached === "true") return;

    // toggleBtn.addEventListener("click", function () {
    //   wrapper.classList.toggle("expanded");
    //   toggleBtn.textContent = wrapper.classList.contains("expanded") ? "Read Less" : "Read More";

    //   if (wrapper.classList.contains("expanded")) {
    //     wrapper.style.height = "240px";
    //     desc.style.webkitLineClamp = "none";
    //   } else {
    //     wrapper.style.height = "197px";
    //     desc.style.webkitLineClamp = 3;
    //   }
    // });

    function checkOverflow() {
  desc.style.webkitLineClamp = "none";
  const fullHeight = desc.scrollHeight;

  desc.style.webkitLineClamp = 3;
  const clampedHeight = desc.clientHeight;

  if (fullHeight <= clampedHeight) {
    toggleBtn.style.display = "none";
  } else {
    toggleBtn.style.display = "block";
  }
}

checkOverflow();

toggleBtn.addEventListener("click", function () {
  wrapper.classList.toggle("expanded");

  if (wrapper.classList.contains("expanded")) {
    wrapper.style.height = "240px";
    desc.style.webkitLineClamp = "none";
    toggleBtn.textContent = "Read Less";
  } else {
    wrapper.style.height = "197px";
    desc.style.webkitLineClamp = 3;
    toggleBtn.textContent = "Read More";
  }
});

    // Mark as bound
    toggleBtn.dataset.listenerAttached = "true";
  });
}